/*
 * API 配置文件
 * 从环境变量读取 API 基础 URL
 */

// 获取 API 基础 URL，优先使用环境变量
const getApiBaseUrl = () => {
  // 从环境变量读取，如果没有则使用默认值
  return process.env.REACT_APP_API_URL || "http://115.29.224.30:8002";
};

// 导出配置
export const API_CONFIG = {
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
};

// 导出获取 baseURL 的函数，供其他地方使用
export const getBaseUrl = getApiBaseUrl;